import { InjectionToken } from '@angular/core';

/**
 * API origins the module needs. Supplied by the host through
 * `provideCustodisModule(...)` rather than read from `environment`, so this
 * folder stays portable — BC_UI's environment shape is nested under apiConfig
 * and the standalone Custodis_UI app's is not.
 */
export interface CustodisModuleConfig {
  /** Origin of the Custodis API. The module appends `/api/v1/custodis`. */
  custodisApiUrl: string;
  /** Origin of BC_Identity. Organisations and staff are read from here, not from Custodis. */
  identityApiUrl: string;
  /** Origin of BC_Corporate. The client list behind the Customers screen is read from here. */
  corporateApiUrl: string;
}

/**
 * The BC_UI company whose clients the Customers screen lists — BC_Corporate scopes its customer
 * endpoints by company id, unlike Identity's org-scoped ones which need no argument.
 *
 * A token rather than an import: the company lives in the host's CompaniesService (per-tab, via
 * OrgScopeStore), and this folder deliberately depends on nothing outside itself. The host wires
 * it up on the lazy route — see provideCustodisModule.
 */
export const CUSTODIS_COMPANY_ID = new InjectionToken<() => number | null>('CUSTODIS_COMPANY_ID');

export const CUSTODIS_MODULE_CONFIG = new InjectionToken<CustodisModuleConfig>('CUSTODIS_MODULE_CONFIG');
